import { getAjax, postAjax } from './index.js';

/**************************************订单设置**************************************/

/**
 * 获取交易配置
 * @param {*} params
 * @returns
 */
export const getTradeConfigInfo = async params => {
  const { data = {} } = await getAjax('trade/config/info', params);
  return data;
};

// 获取新版配置
export const tradeConfigInfoNew = async () => {
  const res = await getAjax('trade/config/new/query');
  const configs = {};
  (res.data || []).forEach(({ configKey, configValue }) => {
    try {
      configs[configKey] = typeof configValue === 'string' ? JSON.parse(configValue) : configValue;
    } catch {
      configs[configKey] = configValue;
    }
  });
  return configs;
}

/**
 * 保存交易配置
 * @param {*} params
 * @returns
 */
export const updateTradeConfig = async params => {
  const res = await postAjax('trade/config/update', params);
  return res;
};

/**
 * 保存新版交易配置
 * @param {*} params
 * @returns
 */
export const tradeConfigUpdateNew = async params => {
  const res = await postAjax('trade/config/new/update', params, {appJson: true, submitType: 'json'});
  return res;
};

/**
 * 新增和保存 审单规则列表
 * @param {*} params
 * @returns Object<*>
 */
export const saveTradeConfigAudit = async params => {
  const res = await postAjax('trade/config/audit/save', params, { submitType: 'json' });
  return res;
};

/**
 * 获取审单规则列表
 * @param {*} params
 * @returns
 */
export const getTradeConfigAuditInfo = async params => {
  const { data = {} } = await getAjax('trade/config/audit/info', params);
  return data;
};

/**
 * 获取系统设置交易配置
 * @param {*} params
 * @returns
 */
export const getTradeIndexInfo = async params => {
  const { data = {} } = await getAjax('trade/index/info', params);
  return data;
};
/**************************************智能合单**************************************/

/**
 * 智能合单
 * @param {*} params
 * @returns
 */
export const tradeMergeAutoManual = async params => {
  const res = await postAjax('trade/merge/auto/manual', params);
  return res;
};
